import { render, staticRenderFns } from "./DisparityTag.vue?vue&type=template&id=359d674b&scoped=true&"
import script from "./DisparityTag.vue?vue&type=script&lang=js&"
export * from "./DisparityTag.vue?vue&type=script&lang=js&"
import style0 from "./DisparityTag.vue?vue&type=style&index=0&id=359d674b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359d674b",
  null
  
)

export default component.exports